import { Grid } from '@mui/material'

import ProfileUpload from '../forms/ProfileUploadWrapper' // Import custom File upload wrapper

const ProfilePic = ({ dir }: { dir: string }) => {
  const configGridItem = {
    item: true,
    xs: 12,
  }

  return (
    <Grid
      container
      rowGap={4}
      sx={{
        backgroundColor: '#FAF9F9',
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        mb: 2,
        p: 4,
      }}
    >
      <Grid {...configGridItem}>
        <ProfileUpload folder={dir} name="profile" />
      </Grid>
    </Grid>
  )
}

export default ProfilePic
